class VwServisprotokol1DTO {
    kod: number = null;
    aciklama?: string = "";
    tip?: number = null;
    bagliOrganizasyonId?: number = null;
}
export default VwServisprotokol1DTO;